import PDFModal from './PDFModal.vue';
import { createModal } from '../Modal';

export async function openPDFModal(params = {}) {
  await createModal({
    params,
    component: PDFModal,
  });
}
